<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  .uploads-tab-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    margin-top: 8px;
  }

  .uploads-content {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow-y: auto;
    min-height: 0;
  }

  .helper-text {
    display: flex;
    align-items: center;
    gap: 8px;
    @include mixins.body4;
    color: colors.get(textDisabledGrey);
    flex-shrink: 0;
  }
</style>

<script>
  import Icon from "@sourcewhale/shared/svelte-design-system/components/atoms/Icon.svelte";
  import { persistedFilesStore } from "../stores";
  import FileUploadArea from "./uploads/FileUploadArea.svelte";
  import ProjectSelector from "./uploads/ProjectSelector.svelte";
  import UploadActionButton from "./uploads/UploadActionButton.svelte";

  let isUploading = $state(false);
  let progress = $state(0);
  let errorMessage = $state("");

  const selectedFilesCount = $derived($persistedFilesStore.length);
</script>

<div class="uploads-tab-container">
  <div class="uploads-content">
    <FileUploadArea bind:isUploading {progress} {errorMessage} />

    {#if !isUploading && selectedFilesCount > 0}
      <ProjectSelector />
      <UploadActionButton bind:isUploading bind:progress bind:errorMessage />
    {/if}
  </div>
  <div class="helper-text">
    <Icon class="fa-solid fa-circle-info" size="small" />
    <span
      >Upload resumes to create contacts. Existing contacts will be updated with
      new information found in the resume.</span
    >
  </div>
</div>
